
export const PricingTablesActionTypes = {
    SET_PRICING_TABLES_V2: "SET_PRICING_TABLES_V2",
    CLEAR_PRICING_DETAILS_V2: "CLEAR_PRICING_DETAILS_V2",
    UPDATED_PRICING_TABLE_REFRESH_V2: "UPDATED_PRICING_TABLE_REFRESH_V2",
    SET_PRICING_TABLE_DETAILS_V2: "SET_PRICING_TABLE_DETAILS_V2",
    TOGGLE_PRICING_TABLE_SORT_V2: "TOGGLE_PRICING_TABLE_SORT_V2",
    PRICING_TABLE_GLOBAL_SEARCH_V2: "PRICING_TABLE_GLOBAL_SEARCH_V2",
}

export const addEditPricingTableActionTypes = {
    SETTING_PRICING_FORM_VALUE_V2: "SETTING_PRICING_FORM_VALUE_V2",
    SETTING_PRICING_FORM_DROPDOWN_V2: "SETTING_PRICING_FORM_DROPDOWN_V2",
    SETTING_PRICING_FORM_DESCRIPTION_V2: "SETTING_PRICING_FORM_DESCRIPTION_V2",
    VALIDATE_PRICING_TABLE_FORM_V2: "VALIDATE_PRICING_TABLE_FORM_V2",
    TOGGLE_UPLOAD_PRICING_MODAL: "TOGGLE_UPLOAD_PRICING_MODAL",
    TOGGLE_ADD_PRICING_TABLE_MODAL_V2: "TOGGLE_ADD_PRICING_TABLE_MODAL_V2",
    TOGGLE_EDIT_PRICING_TABLE_MODAL_V2: "TOGGLE_EDIT_PRICING_TABLE_MODAL_V2",
    OPEN_EDIT_PRICING_TABLE_MODAL_V2: "OPEN_EDIT_PRICING_TABLE_MODAL_V2",

    TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2: "TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2",
    CLOSE_COUNTRY_PRICING_MODAL_V2: "CLOSE_COUNTRY_PRICING_MODAL_V2",
    OPEN_EDIT_COUNTRY_PRICING_MODAL_V2: "OPEN_EDIT_COUNTRY_PRICING_MODAL_V2",
    SETTING_COUNTRY_PRICING_FORM_VALUE_V2: "SETTING_COUNTRY_PRICING_FORM_VALUE_V2",
    VALIDATE_COUNTRY_PRICING_FORM_V2: "VALIDATE_COUNTRY_PRICING_FORM_V2",
    DELETE_WARNING_FOR_COUNTRY_PRICING_V2: "DELETE_WARNING_FOR_COUNTRY_PRICING_V2",
}

export const apiActionsPricingTables = {
    GET_V2: "GET_V2_PRICING_TABLE_DETAIL_V2",
    GET_ALL_V2: "FETCH_ALL_PRICING_TABLES_V2",
    POST_V2: "ADD_NEW_PRICING_TABLE_V2",
    PUT_V2: "EDIT_CURRENT_PRICING_TABLE_V2",
    DELETE_V2: "DELETE_CURRENT_PRICING_TABLE_V2",
    DELETE_WARNING_FOR_PRICING_V2: "DELETE_WARNING_FOR_PRICING_V2",
    UPLOAD_PRICING_DATA: "UPLOAD_PRICING_DATA",
}

export const apiActionsCountryPricing = {
    GET_V2: "GET_CURRENT_COUNTRY_PRICING_V2",
    POST_V2: "ADD_NEW_COUNTRY_PRICING_V2",
    PUT_V2: "EDIT_CURRENT_COUNTRY_PRICING_V2",
    DELETE_V2: "DELETE_COUNTRY_PRICING_V2",
}

export const CountryPricingActionTypes = {
    SET_COUNTRY_PRICING_DETAILS_V2: "SET_COUNTRY_PRICING_DETAILS_V2",

    TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2: "TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2",
    TOGGLE_ADD_PRICING_SCHEME_MODAL_V2: "TOGGLE_ADD_PRICING_SCHEME_MODAL_V2",
    OPEN_EDIT_COUNTRY_PRICING_MODAL_V2: "OPEN_EDIT_COUNTRY_PRICING_MODAL_V2",
    CLOSE_COUNTRY_PRICING_MODAL_V2: "CLOSE_COUNTRY_PRICING_MODAL_V2",

    SETTING_COUNTRY_PRICING_FORM_VALUE_V2: "SETTING_COUNTRY_PRICING_FORM_VALUE_V2",
    DELETE_WARNING_FOR_COUNTRY_PRICING_V2: "DELETE_WARNING_FOR_COUNTRY_PRICING_V2",

    SET_COUNTRY_V2: "SET_COUNTRY_V2",
    SET_PRICING_SCHEME_V2: "SET_PRICING_SCHEME_V2",
    VALIDATE_EDIT_COUNTRY_PRICING_FORM_V2: "VALIDATE_COUNTRY_PRICING_FORM_V2",
    EDIT_FLAT_PRICE_V2: "SET_FLAT_PRICE_V2",
    EDIT_VOLUME_TIER_VALUES_V2: "SET_VOLUME_TIER_VALUES_V2",
    ADD_VOLUME_TIER_V2: "ADD_VOLUME_TIER_V2",
    DELETE_VOLUME_TIER_V2: "DELETE_VOLUME_TIER_V2"
}

export const PricingTableSortFields = {
    NAME: "name",
    LAST_UPDATED: "last_updated",
    BASE_PRICE: "base_price",
    COUNTRY_COUNT: "country_count",
    TENANT_COUNT: "tenant_count",
}
